define('notifications',['controller', 'socket', 'header', 'tooltip-notifier'], function(controller, socket, header, tooltipNotifier) {

	$('#header, #content').on('click', '.mark-as-read-icon', onMarkAsReadClick);
	$('#header, #content').on('click', '.mark-all-as-read-button', onMarkAllAsReadClick);
	
	/*
	 * Update the number of unread notifications in the header profile section
	 */
	socket.on('notifications', function() {
		$.get('/account/get_new_notification_count', function(data) {
			if(data > 0) {
				$('.notification-count').parent().addClass('unread');
				$('.notification-count').html(data);
			} else {
				$('.notification-count').parent().removeClass('unread');
				$('.notification-count').html(data);
			}
		});

		if ($('#header-notifications-menu').is(':visible')) {
			header.loadNotificationBox();
		}
	});

	function onMarkAsReadClick() {
		var id = $(this).data('notification-id');
        var button = $(this);

		$.ajax({
			url: '/notifications/' + id + '/read_json',
			type: 'POST',
			dataType: 'json'
		}).done(function() {
            button.hide();
            button.closest('.notification-feed-entry').removeClass('unread');
		}).fail(function(xhr) {
			tooltipNotifier.showError(button, 'Beim als Gelesen Markieren ist ein Fehler aufgetreten', xhr);
		});
	}

	function onMarkAllAsReadClick() {
		var button = $(this);

		$.ajax({
			url: '/notifications/read_all_json',
			type: 'POST',
			dataType: 'json'
		}).done(function() {
			$('#dashboard-mark-as-read-button').hide();
			$('.notification-feed-entry').removeClass('unread');
		}).fail(function(xhr) {
			tooltipNotifier.showError(button, 'Beim als Gelesen Markieren ist ein Fehler aufgetreten', xhr);
		});
	}
	
	function onLoadButtonClick() {
		var loadButton = $('#load-button');
		var load_count = loadButton.data('load-count') + 1;
		
		$.ajax({
			url: '/welcome/load_notifications',
			type: 'POST',
			dataType: 'json',
			data: {load_count: load_count}
		}).done(function(data) {
			$('#notification-feed').append(data.html);
			$('#load-button').data('load-count', load_count);

			if(!data.show_button)
				$('#load-button').hide();
		}).fail(function(xhr) {
			tooltipNotifier.showError(loadButton, '', xhr);
		});
	}
	
	controller.on('dashboard/notifications', function() {
		$('#load-button').click(onLoadButtonClick);
	}, function() {
		//nothing to do
	});
});

